import React from 'react'
import { useContext } from 'react';
import { AuthContext } from '../../components/AuthContext';
import Swal from 'sweetalert2';
export default function Dashboard() {
    const { user } = useContext(AuthContext);
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <h1 className="text-4xl font-bold mb-4">Welcome, {user.name}</h1>
            <p className="text-lg text-gray-600">You are logged in as a company head.</p>
        </div>
    );
}
